import styled from "styled-components";
import { NavLink } from "react-router-dom";
export default styled(NavLink)`
  color: #f4f6f8;
`;
